import {remCalc} from '../_utils'

const radius = {
    null: {
        base: 0,
        sm: 0,
        md: 0,
        lg: 0,
    },
    small: {
        base: remCalc(2),
        sm: remCalc(2),
        md: remCalc(2),
        lg: remCalc(2),
    },
    medium: {
        base: remCalc(4),
        sm: remCalc(4),
        md: remCalc(4),
        lg: remCalc(4),
    },
    large: {
        base: remCalc(8),
        sm: remCalc(8),
        md: remCalc(8),
        lg: remCalc(8),
    },
    button: {
        base: remCalc(0),
        sm: remCalc(0),
        md: remCalc(0),
        lg: remCalc(0),
    },
}

export default radius
